import { createSelector } from 'reselect';
import { IReferenceData } from 'types';
import { selectReferenceState } from './referenceSelectors';

const selectWikiState = (state: IReferenceData) => state.wiki;

export const selectWiki = createSelector(selectReferenceState, selectWikiState);

export const selectWikiByPolicyType = createSelector(
  selectWiki,
  (_, policyType: string) => policyType,
  (wiki, policyType) => wiki.find((w) => w.policyType === policyType),
);
